const MODAL_TYPES = {
  SINGLE_IMAGE: 'single_image',
  CAROUSEL: 'carousel'
};

export default MODAL_TYPES;
